import { VALIDAMOBILE_LOADING, VALIDAMOBILE_SUCCESS, VALIDAMOBILE_ERROR, VALIDAMOBILE_LOGOUT, RESET_PORTAL_CONTEXT} from "../ActionTypes";

import validaMobileInitialState from "../initialStates/validaMobileInitialState";

const validaMobile = (state, { payload, type }) => {
  switch (type) {
    case VALIDAMOBILE_LOADING:
      return {
        ...state,
        validaMobile: {
          ...state.validaMobile,
          error: false,
          loading: true,
        },
      };
    case VALIDAMOBILE_SUCCESS:
      return {
        ...state,
        validaMobile: {
          ...state.validaMobile,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case VALIDAMOBILE_ERROR:
      return {
        ...state,
        validaMobile: {
          ...state.validaMobile,
          error: payload,
          loading: false,
        },
      };

    case VALIDAMOBILE_LOGOUT:
      return validaMobileInitialState; 
      
    case RESET_PORTAL_CONTEXT:
      return validaMobileInitialState; 

    default:
      return state;
  }
};

export default validaMobile;